import { put, call } from 'redux-saga/effects';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';

export function* getWorkOwnerships({ workId }) {
  try {
    const workOwnerships = yield call(API.getWorkOwnerships, workId);
    yield put({
      type: actionTypes.WORK_OWNERSHIPS_GET_SUCCESS,
      workOwnerships,
    });
  } catch (error) {
    yield put({ type: actionTypes.WORK_OWNERSHIPS_GET_ERROR, error });
  }
}

export function* getWorkOwnership({ workId, id }) {
  try {
    const workOwnership = yield call(API.getWorkOwnership, workId, id);
    if (workOwnership.id) {
      yield put({
        type: actionTypes.WORK_OWNERSHIP_GET_SUCCESS,
        workOwnership,
      });
    } else {
      yield put({ type: actionTypes.WORK_OWNERSHIP_GET_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.WORK_OWNERSHIP_GET_ERROR, error });
  }
}

export function* createWorkOwnership({ workOwnership }) {
  try {
    const result = yield call(API.createWorkOwnership, workOwnership);
    if (result.error) {
      yield put({
        type: actionTypes.WORK_OWNERSHIP_CREATE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.WORK_OWNERSHIP_CREATE_SUCCESS,
        workOwnership: result,
      });
    }
  } catch (error) {
    yield put({ type: actionTypes.WORK_OWNERSHIP_CREATE_ERROR, error });
  }
}

export function* updateWorkOwnership({ workOwnership }) {
  try {
    const result = yield call(API.updateWorkOwnership, workOwnership);
    if (result.id) {
      yield put({
        type: actionTypes.WORK_OWNERSHIP_UPDATE_SUCCESS,
        workOwnership: result,
      });
    } else {
      yield put({ type: actionTypes.WORK_OWNERSHIP_UPDATE_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.WORK_OWNERSHIP_UPDATE_ERROR, error });
  }
}

export function* deleteWorkOwnership({ workOwnership }) {
  try {
    yield call(API.deleteWorkOwnership, workOwnership);
    yield put({
      type: actionTypes.WORK_OWNERSHIP_DELETE_SUCCESS,
      id: workOwnership.id,
    });
  } catch (error) {
    yield put({ type: actionTypes.WORK_OWNERSHIP_DELETE_ERROR, error });
  }
}



// WEBPACK FOOTER //
// src/redux/sagas/workOwnerships.js